import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_3 = {
  key: 2,
  class: "badge rounded-pill bg-secondary text-body ms-1 small"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "my-4 d-flex align-items-center mb-0 mt-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", {
  class: "mt-2",
  style: {"height":"2px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Clickable = _resolveComponent("Clickable")!

  return (_ctx.desktop)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabItems, (tab, tabIndex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: tabIndex,
              class: _normalizeClass([tab.props?.extclass])
            }, [
              _createVNode(_component_Clickable, {
                class: _normalizeClass(["nav-link d-flex align-items-center", { active: tabIndex === _ctx.modelValue }]),
                role: "tab",
                "aria-selected": tabIndex === _ctx.modelValue ? 'true' : 'false',
                "aria-controls": `tabpanel-${tabIndex}`,
                onClick: ($event: any) => (_ctx.$emit('update:modelValue', tabIndex))
              }, {
                default: _withCtx(() => [
                  (tab.props?.icon)
                    ? (_openBlock(), _createBlock(_component_Icon, {
                        key: 0,
                        glyph: tab.props.icon,
                        class: "me-1",
                        lg: ""
                      }, null, 8, ["glyph"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(tab.props?.title) + " ", 1),
                  (tab.props?.loading)
                    ? (_openBlock(), _createBlock(_component_Spinner, {
                        key: 1,
                        class: "ms-1",
                        sm: ""
                      }))
                    : _createCommentVNode("", true),
                  (!tab.props?.loading && tab.props?.count)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(tab.props.count), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["aria-selected", "aria-controls", "class", "onClick"])
            ], 2))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabItems, (tab, tabIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            role: "tabpanel",
            id: `tabpanel-${tabIndex}`,
            key: tabIndex,
            style: _normalizeStyle({ display: tabIndex === _ctx.modelValue ? 'block' : 'none' })
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(tab)))
          ], 12, _hoisted_4))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabItems, (tab, tabIndex) => {
          return (_openBlock(), _createElementBlock("div", { key: tabIndex }, [
            _createElementVNode("h4", _hoisted_6, [
              (tab.props?.isLoading)
                ? (_openBlock(), _createBlock(_component_Spinner, {
                    key: 0,
                    class: "me-2",
                    sm: ""
                  }))
                : (tab.props?.icon)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 1,
                      glyph: tab.props.icon,
                      class: "me-2"
                    }, null, 8, ["glyph"]))
                  : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(tab.props?.title), 1)
            ]),
            _hoisted_7,
            (_openBlock(), _createBlock(_resolveDynamicComponent(tab)))
          ]))
        }), 128))
      ]))
}